import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminSubscriptionBulkPriceChangeFormComponent } from '../admin-subscription-bulk-price-change-form/admin-subscription-bulk-price-change-form.component';
import { AdminSubscriptionBulkPriceChangeForm } from '../../models/admin-subscription-bulk-price-change-form';
import { AdminSubscriptionDataSourceService } from '../../services';
import { once } from '@web/utils';

@Component({
  selector: 'app-admin-subscription-bulk-price-change',
  imports: [AlertsComponent, AdminSubscriptionBulkPriceChangeFormComponent],
  templateUrl: './admin-subscription-bulk-price-change.component.html',
  styleUrl: './admin-subscription-bulk-price-change.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminSubscriptionBulkPriceChangeComponent {
  /* prettier-ignore */
  private readonly subscriptionDataSource = inject(AdminSubscriptionDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(
    data: AdminSubscriptionBulkPriceChangeForm,
  ): void {
    this.subscriptionDataSource
      .bulkChangePriceByForm(data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
